<style lang="scss">
  div {
    display: contents;
  }
</style>

<script>
  import { makeEscapeAction } from "../../../utils/escapable";
  import FloatingUI from "../../utils/FloatingUI.svelte";

  export let placement;

  let targetEl;
  let show = false;
  let floatingEl;

  export let onToggle = () => {};

  export const toggle = (e) => {
    // TODO: allow specific target to optionally be passed in (currently floatingUI can be dependent on where click occurs)
    targetEl = e.composedPath()[0] || e.target;
    show = !show;
    onToggle(show);
  };

  export const dismiss = () => {
    show = false;
    onToggle(show);
  };

  export let style = "";

  const windowClick = (e) => {
    if (!floatingEl || !targetEl) return;
    const target = e.composedPath()[0] || e.target;
    if (![targetEl, floatingEl].some((el) => el.contains(target))) {
      dismiss();
    }
  };

  const escape = makeEscapeAction(dismiss);
</script>

<svelte:window on:click={windowClick} />

<div>
  <slot {dismiss} {toggle} />
  {#if show}
    <FloatingUI
      bind:floatingEl
      {style}
      {escape}
      referenceEl={targetEl}
      {placement}
      class="toggletip"
    >
      <slot name="toggletip" />
    </FloatingUI>
  {/if}
</div>
